/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'snabjenie-2': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8.515 6.603A.75.75 0 019.25 6h21a.75.75 0 01.735.603l.88 4.397h4.885a.75.75 0 01.75.75v22.5a.75.75 0 01-.75.75h-34a.75.75 0 01-.75-.75v-22.5a.75.75 0 01.75-.75h4.885l.88-4.397zM9.165 11h21.17l-.7-3.5H9.865l-.7 3.5zm-4.21 1.5L15 20.227v-.477a.75.75 0 01.75-.75h8a.75.75 0 01.75.75v.477L34.545 12.5H4.955zM36 13.273L24.5 22.12v1.631a.75.75 0 01-.75.75h-8a.75.75 0 01-.75-.75v-1.63L3.5 13.272V33.5H36V13.273zM16.5 20.5V23H23v-2.5h-6.5z" _fill="#15386C"/>'
  }
})
